import { TbAppWindow, TbVideo } from "solid-icons/tb";
import type { Component } from "solid-js";
import { Dynamic } from "solid-js/web";
import { useI18n } from "~/i18n";
import type { TranslationKey } from "~/i18n/translations";
import { type InsightsData as Data, InsightsApp, InsightsCall } from "./internal/InsightScenes";
import { SceneTabs } from "./internal/SceneTabs";

export type InsightsData = Data;

const VIEWS: { tab: TranslationKey; alt: TranslationKey; icon: typeof TbVideo; scene: typeof InsightsCall }[] = [
  {
    tab: "marketing.mock.insights.tab_call",
    alt: "marketing.mock.insights.alt_call",
    icon: TbVideo,
    scene: InsightsCall,
  },
  { tab: "marketing.mock.insights.tab_app", alt: "marketing.mock.insights.alt", icon: TbAppWindow, scene: InsightsApp },
];

/**
 * Chief being proactive, where it shows up: on the call, out of the notch,
 * and in the desktop app's Activity panel. Each scene starts
 * from a line said on the call, so the card reads as the answer to it.
 */
export const InsightsMockup: Component<{ data: InsightsData }> = (props) => {
  const { t } = useI18n();
  return (
    <SceneTabs
      items={VIEWS}
      label={t("marketing.mock.insights.tabs_label")}
      tab={(view) => (
        <>
          <view.icon class="size-4" aria-hidden="true" />
          {t(view.tab)}
        </>
      )}
    >
      {(view) => <Dynamic component={view.scene} data={props.data} label={t(view.alt)} />}
    </SceneTabs>
  );
};
